import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss';
import { ReactComponent as Improve_control_and_stabilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_control_and_stability.svg';
import { ReactComponent as Build_functional_strengthIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_functional_strength.svg';
import { ReactComponent as Support_sport_performanceIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/support_sport_performance.svg';
import { ReactComponent as Improve_compound_liftsIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_compound_lifts.svg';
import { ReactComponent as Lift_heavier_weightsIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/lift_heavier_weights.svg';

interface IncreaseStrengthStep2Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  lift_heavier_weights: <Lift_heavier_weightsIcon />,
  build_functional_strength: <Build_functional_strengthIcon />,
  improve_compound_lifts: <Improve_compound_liftsIcon />,
  improve_control_stability: <Improve_control_and_stabilityIcon />,
  support_sport_performance: <Support_sport_performanceIcon />,
};

// What strength outcome matters most?
export const IncreaseStrengthStep2: FC<IncreaseStrengthStep2Props> = ({ value, onNext }) => {
  const [selectedOutcome, setSelectedOutcome] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const stepData = programMasterData?.trainingGoalPreferences?.groups?.find(
    (item: any) => item.goalId === 'increase_strength',
  );

  const title = stepData?.title;
  const options = stepData?.options
    ? [...stepData.options].sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !stepData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{title}</h2>

      <div className="goal-buttons">
        {options.map((option: any) => {
          const icon = iconMap[option.id] || iconMap[option.image] || null;

          return (
            <button
              key={option.id}
              className={`goal-btn ${selectedOutcome === option.slug ? 'selected' : ''}`}
              onClick={() => {
                setSelectedOutcome(option.slug);
                if (onNext) onNext(option.slug);
              }}
            >
              <div className="goal-icon">{icon}</div>
              <span className="goal-label">{option.title}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
